import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.css";
import Modal from "react-bootstrap/Modal";
import * as constantMessages from "../../constants/constatntMessages";
import { checkCharacterLeft } from "../../helpers/commonHelpers";
import { textBoxStrLength } from "../../config/config";
import { useSelector, useDispatch } from "react-redux";
import {
  approveActionInLastMinuteActions,
  reopenActionInLastMinuteActions,
  fetchSingleAction,
  getactionActivitiesDetails,
} from "../../redux/actions/actionAction/ActionAction";
import LoaderButton from "../Common/LoaderButton";
import { viewParentMeeting } from "../../redux/actions/meetingActions/MeetingAction";
import SmallLoaderButton from "../Common/SmallLoaderButton";
const ReopenActionModal = React.memo((props) => {
  const dispatch = useDispatch();
  const [reason, setReason] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const actionData = useSelector((state) => state.action);
  const regularExpressionForAgendaTitle =
    /^[0-9a-zA-Z .,:\n;%@&#!$^*+=()/_'"\\\-?|{}\[\]]+$/;
  useEffect(() => {
    if (actionData?.isSuccess === true) {
      props.setIsReopenMinuteModal(false);
    }
    return () => {
      setReason("");
    };
  }, [actionData.isSuccess]);

  const handleSubmit = async () => {
    const newErrors = validateForm();
    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      let payload;
      if (props.isCalledFromViewAction === false) {
        payload = {
          remark: reason,
          assignedUserDetails: props?.minuteDetails?.assignedUserDetails,
        };
      } else {
        payload = {
          remark: reason,
          assignedUserDetails: props?.minuteDetails?.assignedUserDetail,
        };
      }
      setLoading(true);
      const result = await dispatch(
        reopenActionInLastMinuteActions(
          props.parentMeetingId,
          props?.minuteDetails?._id,
          payload,
          props?.accessToken
        )
      );
      setLoading(false);
      console.log("props.childMeetingId-->", props.childMeetingId);
      if (result?.status) {
        if (props.isCalledFromViewAction === true) {
          dispatch(fetchSingleAction(props?.actionId, props?.accessToken));
          dispatch(
            getactionActivitiesDetails(props?.actionId, props?.accessToken)
          );
        }

        if (props.parentMeetingId && props?.accessToken) {
          dispatch(viewParentMeeting(props.childMeetingId, props?.accessToken));
        }

        props.setIsReopenMinuteModal(false);
        setReason("");
      }
    }
  };

  const handleApproveSubmit = async () => {
    let payload;
    if (props.isCalledFromViewAction === true) {
      payload = {
        remark: reason,
        assignedUserDetails: props?.minuteDetails?.assignedUserDetail,
      };
    } else {
      payload = {
        remark: reason,
        assignedUserDetails: props?.minuteDetails?.assignedUserDetails,
      };
    }
    console.log(
      "props?.minuteDetails-->",
      props?.minuteDetails?.assignedUserDetail
    );
    // const payload = {
    //   remark: reason,
    //   assignedUserDetails: props?.minuteDetails?.assignedUserDetail,
    // };
    setLoading(true);
    const result = await dispatch(
      approveActionInLastMinuteActions(
        props.parentMeetingId,
        props?.minuteDetails?._id,
        payload,
        props?.accessToken
      )
    );
    if (props.isCalledFromViewAction === true) {
      dispatch(getactionActivitiesDetails(props?.actionId, props?.accessToken));
    }
    setLoading(false);
    if (result?.status) {
      if (props.isCalledFromViewAction) {
        dispatch(fetchSingleAction(props?.actionId, props?.accessToken));
      }

      if (props.parentMeetingId && props?.accessToken) {
        dispatch(viewParentMeeting(props.childMeetingId, props?.accessToken));
      }

      props.setIsReopenMinuteModal(false);
      setReason("");
    }
  };
  const validateForm = () => {
    const errors = {};
    if (!reason.trim()) {
      errors.reason = constantMessages.reasonRequired;
    } else if (!regularExpressionForAgendaTitle.test(reason.trim())) {
      errors.reason = constantMessages.titleRegexError;
    } else if (reason.trim().length < 3 || reason.trim().length > 500) {
      errors.reason = constantMessages.largeStringLengthError;
    }
    setErrors(errors);
    return errors;
  };

  const closeModal = () => {
    setReason("");
    setErrors({});
    props.setIsReopenMinuteModal(false);
  };

  const updateValues = (e) => {
    setErrors({});
    const { name, value } = e.target;
    if (value.length <= textBoxStrLength) {
      setReason(value);
    }
  };

  return (
    <>
      <Modal
        show={props?.IsReopenMinuteModal}
        onHide={closeModal}
        backdrop="static"
      >
        {props?.minuteDetails?.modalStatus === "REOPEN" ? (
          <>
            <div className="modal-header">
              <h4 className="modal-title">Reopen Action</h4>

              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={closeModal}
              ></button>
            </div>
            <div className="modal-body delete-txt">
              <label className="mb-1">
                {" "}
                Reason
                <span className="star-mark">*</span>
              </label>

              <textarea
                cols="40"
                rows="4"
                id="remark"
                name="remark"
                onBlur={validateForm}
                onChange={updateValues}
                value={reason}
                required
              ></textarea>
              <p className="success-message">
                {checkCharacterLeft(reason)} Characters left
              </p>
              {errors.reason && (
                <span className="error-message">{errors.reason}</span>
              )}
            </div>

            <div className="modal-footer">
              {loading ? (
                <SmallLoaderButton />
              ) : (
                <button
                  type="button"
                  onClick={handleSubmit}
                  className="Mom-btn btn btn-secondary bg-primary border-primary"
                >
                  <p>Reopen</p>
                </button>
              )}
            </div>
          </>
        ) : (
          <>
            <div className="modal-header">
              <h4 className="modal-title">Approve Action</h4>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={closeModal}
              ></button>
            </div>
            <div className="modal-body delete-txt">
              <h6>Remark</h6>
              <textarea
                cols="40"
                rows="4"
                id="remark"
                name="remark"
                onChange={updateValues}
                value={reason}
                required
              ></textarea>
              <p className="success-message">
                {checkCharacterLeft(reason)} Characters left
              </p>
              {errors.reason && (
                <span className="error-message">{errors.reason}</span>
              )}
            </div>

            <div className="modal-footer">
              {loading ? (
                <SmallLoaderButton />
              ) : (
                <button
                  type="button"
                  onClick={handleApproveSubmit}
                  className="Mom-btn btn btn-secondary bg-primary border-primary"
                >
                  <p>Approve</p>
                </button>
              )}
            </div>
          </>
        )}
      </Modal>
    </>
  );
});

export default ReopenActionModal;
